export const BUBBLE_COLORS = Object.freeze({
  ocean: '#3BA6FF',
  teal: '#14B8A6',
  emerald: '#22C55E',
  lime: '#84CC16',
  amber: '#F59E0B',
  orange: '#F97316',
  red: '#EF4444',
  coral: '#FB7185',
  slate: '#64748B',
  honey: '#B45309'
});

export const DEFAULT_BUBBLE_COLOR = 'ocean';

export const isValidBubbleColor = (key) =>
  typeof key === 'string' && Object.prototype.hasOwnProperty.call(BUBBLE_COLORS, key);

export const getBubbleHex = (key) => (isValidBubbleColor(key) ? BUBBLE_COLORS[key] : BUBBLE_COLORS[DEFAULT_BUBBLE_COLOR]);

export const hexToRgb = (hex) => {
  const s = String(hex || '').replace('#', '').trim();
  if (s.length !== 6) return { r: 59, g: 166, b: 255 }; // ocean fallback
  const r = parseInt(s.slice(0, 2), 16);
  const g = parseInt(s.slice(2, 4), 16);
  const b = parseInt(s.slice(4, 6), 16);
  return { r, g, b };
};

export const rgba = (hex, a) => {
  const { r, g, b } = hexToRgb(hex);
  const alpha = Math.max(0, Math.min(1, Number(a)));
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const clamp01 = (n) => Math.max(0, Math.min(1, Number(n)));

export const rgbToHex = ({ r, g, b }) => {
  const to = (v) => Math.max(0, Math.min(255, Math.round(v))).toString(16).padStart(2, '0');
  return `#${to(r)}${to(g)}${to(b)}`;
};

// Mix two hex colors. t=0 -> a, t=1 -> b
export const mixHex = (aHex, bHex, t) => {
  const t01 = clamp01(t);
  const a = hexToRgb(aHex);
  const b = hexToRgb(bHex);
  return rgbToHex({
    r: a.r + (b.r - a.r) * t01,
    g: a.g + (b.g - a.g) * t01,
    b: a.b + (b.b - a.b) * t01
  });
};

